<template>
  <div id="mobilenavwrapper">

      <router-link class="menu-user" to="/Home">
        <font-awesome-icon icon="home" />
      </router-link>

      <div id="nav-icon" ref="nav-icon" v-bind:class="{ active: isActive }" v-on:click="toggle">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div v-if="seen" class="dropmenu" v-closable="{exclude: ['nav-icon'],handler: 'closeModal'}">
          <ul>
              <li><router-link to="/" >Home Page</router-link></li>
              <li><router-link to="/Tutorial">Start Tutorial</router-link></li>
              <li><router-link to="/HowItWorks">How it Works</router-link></li>
              <!-- <li>
                <vue-page-transition name="fade-in-left">
                  <router-link to="/PageOne" replace>Page Uno</router-link>
                </vue-page-transition>
              </li> -->
          </ul>
      </div>

      <div class="clear">
        
      </div>
      
  </div>
</template>

<script>

//http://localhost:8080/{ name: 'PageOne', meta: { transition: overlay-up-down }}

// import firebase from 'firebase/app';
// import 'firebase/auth'; 
// import 'firebase/firestore';
// import 'firebase/functions';
// import { store } from '../store/store';
// import { db } from '../main.js';


export default {

  data: function() {
    return {
		isActive: false,
      	seen: false,
    }
  },

  watch:{
    $route () {
        this.isActive = false;
        this.seen = false
    }
  },

  // created () {
  //   this.$router.beforeEach((to, from, next) => {
  //     this.transition = to.meta.transition
  //       ? to.meta.transition
  //       : this.$props.name
  //     next()
  //   })
  // },

  methods: {
	
	toggle: function () {
      this.isActive = !this.isActive;
      this.seen = !this.seen;
    },

    closeModal: function() {
      this.isActive = !this.isActive;
      this.seen = !this.seen;
    },

  },


};
</script>

<style lang="scss">

@import "././node_modules/bulma/sass/utilities/_all.sass";

  #mobilenavwrapper {
    .user-status {
      position: absolute;
      right: 118px;
      top: 19px;
      font-size: 16px;
      color: #fbc51b;
      // @include mobile {
      //   display: none;
      // }
    }
  }





</style>